import {EventDispatcher as ThreeEventDispatcher} from 'three'
import Utils from './util'

class RenderEventDispatcher extends ThreeEventDispatcher {
  constructor(...args) {
    super(...args)
  }

  once(type, fn) {
    const callback = (...e) => {
      fn(...(e || []))
      // Don't mutate the array while we iterate it,
      // cause this to eval sometime after
      // this chain of event dispatch finishes
      // in `THREE.EventDispatcher.dispatchEvent'
      Utils.defer(() => {
        this.removeEventListener(type, callback)
      })
    }
    this.addEventListener(type, callback)
  }
}

export default RenderEventDispatcher
